import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/sections/HeroSection';
import TrustBar from '../../components/feature/sections/TrustBar';
import ServicesOverview from '../../components/feature/sections/ServicesOverview';
import AIAnswerBlock from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import TestimonialsSection from '../../components/feature/sections/TestimonialsSection';
import FAQSection from '../../components/feature/sections/FAQSection';
import FinalCTASection from '../../components/feature/sections/FinalCTASection';

const trustItems = [
  { icon: 'ri-history-line', text: 'Family-Owned Since 1998', subtext: '25+ Years in Brooklyn' },
  { icon: 'ri-star-fill', text: '600+ Five-Star Reviews', subtext: 'Google & Yelp' },
  { icon: 'ri-team-line', text: 'In-House Install Crews', subtext: 'No subcontractors' },
  { icon: 'ri-store-3-line', text: '5,000 sq ft Showroom', subtext: '500+ Samples' },
  { icon: 'ri-map-pin-line', text: 'Brooklyn Locals', subtext: 'Rooted in the community' },
];

const services = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Our Expertise',
    description: 'Over 25 years of hands-on experience in flooring sales and installation — carpet, tile, stone, LVP, and area rugs for homes and businesses across Brooklyn.',
    href: '/services',
    image: 'https://public.readdy.ai/ai/img_res/e32fd96e7987047aa1c26626d9f2ec62.jpg',
  },
  {
    icon: 'ri-tools-line',
    title: 'Carpet Installation',
    description: 'Expert carpet installation for residential and commercial spaces throughout Brooklyn and all NYC boroughs.',
    href: '/services',
  },
  {
    icon: 'ri-artboard-line',
    title: 'Tile & Stone',
    description: 'Ceramic, porcelain, marble, and natural stone installed with precision craftsmanship by our experienced tile crews.',
    href: '/services',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Luxury Vinyl Plank',
    description: 'Waterproof, durable LVP for kitchens, bathrooms, and high-traffic living areas — beautiful and practical.',
    href: '/services',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Area Rugs',
    description: 'Curated collection of handmade, Oriental, Persian, and modern area rugs available in our Brooklyn showroom.',
    href: '/services',
  },
];

const aiColumns = [
  {
    heading: 'Who We Are',
    paragraphs: [
      'Boro Rug & Flooring is a family-owned flooring showroom and installation company rooted in Brooklyn since 1998. Founded on a love of fine flooring and craftsmanship, we\'ve grown into one of Brooklyn\'s most trusted names for flooring sales, design guidance, and professional installation.',
      'Our team of experienced consultants and licensed installers works together to deliver a seamless experience — from your first showroom visit to the final walkthrough.',
    ],
  },
  {
    heading: 'Our Specialization',
    paragraphs: [
      'We specialize in all major flooring categories: wall-to-wall carpet, tile and natural stone, luxury vinyl plank (LVP), and decorative area rugs. Unlike big-box retailers, we bring personalized expertise, quality materials, and in-house installation under one roof.',
    ],
    bullets: [
      'Carpet: plush, berber, pattern & commercial',
      'Tile: ceramic, porcelain & natural stone',
      'LVP: waterproof, wood & stone visuals',
      'Area rugs: handmade & contemporary',
    ],
  },
  {
    heading: 'Our Philosophy',
    paragraphs: [
      'We believe great flooring starts with honest advice. That\'s why our consultants take time to understand your lifestyle, budget, and design vision before making a single recommendation. We\'d rather sell you the right floor once than the wrong floor twice.',
    ],
  },
  {
    heading: 'Community & Reputation',
    paragraphs: [
      'After 25 years in Brooklyn, our reputation is our greatest asset. We\'ve built it project by project — with fair pricing, skilled installation, and genuine care for every client. Over 600 five-star reviews reflect what we stand for.',
    ],
    bullets: [
      'Family-owned and operated',
      '600+ verified five-star reviews',
      'Active in Brooklyn community',
      'Supporting local since 1998',
    ],
  },
];

const aiStats = [
  { value: '1998', label: 'Year we opened in Brooklyn' },
  { value: '5K+', label: 'Flooring projects completed' },
  { value: '600+', label: 'Five-star client reviews' },
  { value: '500+', label: 'Showroom flooring samples' },
];

const processSteps = [
  { icon: 'ri-chat-smile-3-line', title: 'Listen First', description: 'We start by understanding your space, lifestyle, and taste — not pushing products. Great flooring begins with the right questions.' },
  { icon: 'ri-store-3-line', title: 'Showroom Tour', description: 'Our consultants guide you through 500+ samples, explaining the tradeoffs of each material honestly and clearly.' },
  { icon: 'ri-home-4-line', title: 'In-Home Estimate', description: 'We visit your space, take precise measurements, and provide a detailed estimate you can count on.' },
  { icon: 'ri-tools-line', title: 'Expert Install', description: 'Our own crews handle everything — no subcontractors. Every install reflects our 25 years of accumulated expertise.' },
  { icon: 'ri-checkbox-circle-line', title: 'Quality Sign-Off', description: 'We don\'t consider a job done until you\'re completely satisfied. Final walkthroughs are thorough and honest.' },
  { icon: 'ri-customer-service-2-line', title: 'Ongoing Support', description: 'We stand behind our work. If anything needs attention after install, we\'re here — no runaround, no delay.' },
];

const benefits = [
  { icon: 'ri-history-line', title: '25+ Years of Experience', description: 'Opened in Brooklyn in 1998 with a commitment to quality over quantity. That commitment hasn\'t changed.' },
  { icon: 'ri-hand-heart-line', title: 'Genuine Craftsmanship', description: 'Our installers take pride in their work. Details matter to us — from subfloor prep to final trim.' },
  { icon: 'ri-team-line', title: 'In-House Teams Only', description: 'We never use subcontractors. Your project is handled start to finish by our own trained, accountable crews.' },
  { icon: 'ri-eye-line', title: 'Honest Consultations', description: 'We recommend what\'s best for your project — not the highest-margin product. Our reviews reflect that trust.' },
  { icon: 'ri-community-line', title: 'Deep Brooklyn Roots', description: 'We live and work in Brooklyn. Our neighbors are our clients, and we take that responsibility seriously.' },
];

const areas = [
  'Brooklyn', 'Park Slope', 'Flatbush', 'Crown Heights', 'Williamsburg',
  'Bay Ridge', 'Bensonhurst', 'DUMBO', 'Cobble Hill', 'Prospect Heights',
  'Manhattan', 'Queens', 'Staten Island', 'The Bronx',
];

const testimonials = [
  {
    name: 'Patricia W.',
    location: 'Park Slope, Brooklyn',
    rating: 5,
    text: 'I\'ve been a customer of Boro Rug & Flooring for over ten years. They\'ve done carpet, tile, and LVP in my home across three different projects. Every single time, the quality and professionalism have been absolutely outstanding. They\'re the only company I trust with my floors.',
    service: 'Long-Term Customer',
  },
  {
    name: 'James N.',
    location: 'Crown Heights, Brooklyn',
    rating: 5,
    text: 'What I appreciate most is their honesty. When I asked about a more expensive tile, the consultant actually steered me toward a better-value option that looked just as beautiful. That kind of advice is rare and earns loyalty.',
    service: 'Tile & Stone Flooring',
  },
  {
    name: 'Sandra L.',
    location: 'Cobble Hill, Brooklyn',
    rating: 5,
    text: 'Family-run businesses like this are what make Brooklyn special. The owner was personally involved in our project. They treated our home with respect, delivered on every promise, and the carpets look incredible.',
    service: 'Carpet Installation',
  },
  {
    name: 'Kevin T.',
    location: 'Bay Ridge, Brooklyn',
    rating: 5,
    text: 'Twenty-five years in business says everything. These are craftspeople who take real pride in their work. Our LVP floors are flawless — not a single seam out of place.',
    service: 'LVP Installation',
  },
];

const faqs = [
  {
    question: 'How long has Boro Rug & Flooring been in business?',
    answer: 'Boro Rug & Flooring has been serving Brooklyn since 1998 — over 25 years of flooring expertise. We\'re a family-owned and operated business with deep roots in the Brooklyn community. Our longevity reflects the trust our clients place in us and our commitment to quality on every project.',
  },
  {
    question: 'Do you use your own installation crews?',
    answer: 'Yes, absolutely. We employ our own licensed, insured installation crews for every project — we never use subcontractors. This means consistent quality, accountability, and craftsmanship on every job. Our crews have worked together for years and know our standards inside and out.',
  },
  {
    question: 'What flooring brands do you carry?',
    answer: 'We partner with top flooring brands including Shaw, Mohawk, Armstrong, MSI Stone, and other premium manufacturers. Our Brooklyn showroom stocks over 500 samples across carpet, tile, natural stone, luxury vinyl plank, and area rugs. Our consultants can guide you to the right product for your budget.',
  },
  {
    question: 'Can I take flooring samples home?',
    answer: 'Absolutely — we encourage it! We offer free sample lending so you can evaluate how flooring looks in your home\'s lighting and with your existing furniture and décor. Seeing materials in person before you commit is one of the biggest advantages of working with a showroom like ours.',
  },
  {
    question: 'Do you offer any warranty on installation?',
    answer: 'Yes, we stand behind our installation work with a satisfaction guarantee. If any installation issue arises after your project is complete, contact us and we will address it promptly at no charge. We also honor the manufacturer warranties on all materials we sell and install.',
  },
  {
    question: 'How do I get started with Boro Rug & Flooring?',
    answer: 'Visit our Brooklyn showroom at 1247 Flatbush Ave Monday through Friday 9am–6pm or Saturday 10am–5pm. You can also call (718) 555-0100 or request a free estimate online. We\'ll schedule an in-home measurement and consultation at your convenience.',
  },
];

export default function AboutPage() {
  return (
    <div className="bg-ivory">
      <Navbar />

      <HeroSection
        headline="Brooklyn's Trusted Flooring Showroom & Installation Experts"
        subheadline="Family-owned since 1998, serving Brooklyn homeowners and businesses with premium flooring sales and expert installation."
        primaryCTA={{ label: 'Visit Our Showroom', href: '/brooklyn' }}
        secondaryCTA={{ label: 'Get Free Estimate', href: '/#quote' }}
        trustSignal="25+ years of Brooklyn flooring expertise"
        bgImage="https://readdy.ai/api/search-image?query=family%20owned%20flooring%20showroom%20brooklyn%20interior%20design%20staff%20helping%20customer%20choose%20carpet%20samples%20bright%20white%20showroom%20warm%20friendly%20welcoming%20professional%20retail%20store%20natural%20daylight&width=1400&height=900&seq=hero-about2&orientation=landscape"
        badge="Family-Owned Brooklyn Business Since 1998"
        floatingBadgeTitle="600+ 5-Star Reviews"
        floatingBadgeText="Brooklyn's most trusted flooring specialists"
      />

      <TrustBar items={trustItems} />

      <ServicesOverview
        title="Our Flooring Expertise"
        subtitle="25 years of premium flooring knowledge and installation excellence — for Brooklyn homes and businesses."
        services={services}
        ctaLabel="See Service Details"
      />

      <AIAnswerBlock
        badge="About Boro Rug & Flooring"
        title="Brooklyn's Flooring Specialists — 25 Years of Excellence"
        headline="We are a family-owned flooring company in Brooklyn built on honest advice, quality materials, and skilled installation."
        columns={aiColumns}
        stats={aiStats}
        sidebarTitle="Our Track Record"
      />

      <ProcessSection
        title="How We Work With You"
        subtitle="Our process is built around transparency, expertise, and your complete satisfaction — from first consultation to finished floor."
        steps={processSteps}
      />

      <WhyChooseUs
        title="Craftsmanship Is What We Stand For"
        subtitle="We don't just sell floors — we design, install, and stand behind them. Every project reflects 25 years of accumulated expertise."
        benefits={benefits}
        image="https://readdy.ai/api/search-image?query=experienced%20flooring%20installation%20professional%20measuring%20room%20for%20carpet%20installation%20bright%20natural%20light%20modern%20brooklyn%20home%20interior%20professional%20craftsman&width=800&height=700&seq=why-about2&orientation=portrait"
        image2="https://readdy.ai/api/search-image?query=flooring%20showroom%20display%20wall%20with%20multiple%20carpet%20and%20tile%20samples%20well%20organized%20bright%20professional%20interior%20design%20consultation%20space&width=400&height=300&seq=why-about2b&orientation=landscape"
        ctaLabel="Schedule Consultation"
        badge="Our Commitment"
        badgeTitle="Family-Owned"
        badgeSubtext="Since 1998 in Brooklyn"
      />

      <ServiceAreas
        title="Serving All of Brooklyn & Beyond"
        subtitle="In-home estimates available throughout New York City."
        description="Based in Brooklyn, Boro Rug & Flooring serves homeowners and businesses across all Brooklyn neighborhoods and all five NYC boroughs. Whether you\'re in Park Slope or Bay Ridge, DUMBO or Bensonhurst — we come to you for your free in-home estimate and measurement."
        areas={areas}
      />

      <TestimonialsSection testimonials={testimonials} />

      <FAQSection
        title="About Boro Rug & Flooring — FAQ"
        faqs={faqs}
      />

      <FinalCTASection
        headline="Let's Build Something Beautiful"
        subheadline="Visit our Brooklyn showroom or request a free in-home estimate. We're ready to bring your flooring vision to life."
        bgImage="https://readdy.ai/api/search-image?query=elegant%20brooklyn%20home%20interior%20with%20stunning%20new%20flooring%20light%20wood%20plank%20floors%20beautiful%20neutral%20decor%20bright%20spacious%20living%20room%20premium%20renovation%20high%20end%20residential&width=1600&height=900&seq=cta-about2&orientation=landscape"
        formAction="https://readdy.ai/api/form/d6umjl5t4s7j0tv5i6b0"
        checkItems={['Free in-home estimates', 'Expert consultants', 'Brooklyn-based since 1998']}
      />

      <Footer />
    </div>
  );
}
